<div class="alert alert-success" role="alert">
  <h4 class="alert-heading">Proceso de matrícula cancelado.</h4>
  <p class="mb-0">En breve ser&aacute; redirigido autom&aacute;ticamente hacia la pantalla de inicio</p>
  <hr />
  <p class="mb-0"></p>
</div>